<template>
    <div>
        <div class="space-web visible-lg visible-md"></div>
        <div class="space-mobil visible-xs visible-sm"></div>
        <!-- Termina Space -->

        <!-- Banner Horizontal -->
        <div class="banner visible-lg visible-md animated slideInDown">
            <div class="container" v-if="company">
                <div id="sas_31458">
                    <script2 v-if="company.WWonlineBannerTopFM">
                        {{ company.WWonlineBannerTopFM }}
                    </script2>
                </div>
            </div>
        </div>

        <!-- Contenido -->
        <div class="contenido-resultados" >
            <div class="container">
                <div class="row">
                    <div class="col-md-8">
                        <!-- Ficha Empresa -->
                        <div class="contacto-empresa animated slideInLeft">
                            <div class="row"  v-if="(typeof company !== 'undefined' )" >
                                <div class="col-md-4" align="center">
                                    <div class="imagen-persona-empresa" >
                                        <router-link  :to="'/empresa/'+company.permalink" >
                                            <img :src="getImageUrl(company.Images)" width="100%"></img>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="col-md-8 info-resultado" style="padding-bottom: 20px;">
                                    <router-link  :to="'/empresa/'+companyID" v-if="(typeof company !== 'undefined' ) && company">
                                        <h1 v-html="company.CompanyName"  v-if="company.CompanyName" ></h1>
                                    </router-link>
                                    <p class="year" v-if="company.FundacionYear > 0">Año de fundación : <span v-html="company.FundacionYear"></span></p>

                                    <h2 v-html="company.NombreCategory"  v-if="company.NombreCategory"  ></h2>

                                    <p v-html="company.Address1"   v-if="company.Address1"  ></p>
                                    <p v-html="company.citiName" v-if="company.citiName"  ></p>

                                    <p v-if="company.Telefono1"> {{company.Telefono1}}</p>
                                    <p v-if="company.Fax1"> {{company.Fax1}}</p>
                                    <a :href="(company.URL.includes('https') ? company.URL : 'https://'+company.URL)" v-if="(typeof company.URL !== 'undefined' )" target="_blank"><p class="title" v-html="company.URL"></p>
                                    </a>
                                    <!-- <p  v-html="company.URL"  v-if="(typeof company.URL !== 'undefined' )" >www.televisa.com</p> -->
                                    <p class="title"  v-if="(typeof company.NombreActivity !== 'undefined' )" ><strong>Actividad de la Empresa</strong></p>
                                    <p v-html="company.NombreActivity" v-if="(typeof company.NombreActivity !== 'undefined' )" ></p>
                                    <p class="title" v-if="company.Descripcion && company.Descripcion.length"><strong>Descripción de la empresa:</strong></p>
                                    <p class="text" v-html="company.Descripcion"  v-if="company.Descripcion && company.Descripcion.length"></p>
                                    <p v-if="company.Especialidad && company.Especialidad.length"><strong>Especialidad:</strong></p>
                                    <p v-html="company.Especialidad"  v-if="company.Especialidad && company.Especialidad.length"></p>
                                </div>
                            </div>
                        </div>

                        <!-- Ficha Persona -->
                        <div class="contacto-persona animated slideInLeft" v-if="contact && contact !== null">
                            <div class="row" v-if="contact && contact !== null">
                                <div class="col-md-4" align="center">
                                    <div class="imagen-persona-contacto">
                                        <div class="feat-image"
                                            :style="{ 'background-image': 'url(' + getImageUrl(contact.image && contact.image.url ? contact.image.url : '') + ')' }"
                                            @click="$router.push('/contacto/' + contact.slug)"
                                            style="cursor:pointer">
                                        </div>
                                        <!-- <router-link v-if="contact.permalink" :to="'/contacto/' + contact.permalink">
                                            <div class="feat-image" v-if="contact.image && contact.image.url" :style="{ 'background-image': 'url(' + getImageUrl(contact.image.url) + ')' }"></div>
                                            <div class="feat-image" v-else :style="{ 'background-image': 'url(' + getImageUrl('') + ')' }"></div>
                                        </router-link> -->
                                    </div>
                                </div>
                                <div class="col-md-8 info-resultado">
                                    <router-link v-if="contact.slug" :to="'/contacto/' + contact.slug">
                                        <h1 v-if="contact.title" v-html="contact.title"></h1>
                                    </router-link>
                                    <h2 v-if="contact.company && contact.company.position" v-html="contact.company.position"></h2>
                                    <router-link v-if="companyID && company && company.CompanyName" :to="'/empresa/' + companyID">
                                        <h3 v-html="company.CompanyName"></h3>
                                    </router-link>
                                    <p v-if="company && company.NombreCategory" v-html="company.NombreCategory"></p>
                                </div>
                            </div>
                        </div>

                        <app-content v-if="company && company.id" :company="company" :key="company.id"></app-content>
                    </div>

                    <div class="col-md-4 animated slideInRight">
                        <div class="banner" v-if="(typeof company.WWonlineBannerLat1FM !== 'undefined')">
                            <div id="sas_31459">
                                <script2 v-if="company.WWonlineBannerLat1FM">
                                    {{ company.WWonlineBannerLat1FM }}
                                </script2>
                            </div>
                        </div>

                        <!-- Empresas -->
                        <div class="empresa"  v-if="contactCompanies[0] && (typeof contactCompanies !== 'undefined' ) ">
                            <h1>EMPRESA</h1>
                            <hr>
                            <div class="scroll-empresa">
                                <div class="lista-empresa">
                                    <router-link :to="'/empresa/'+contactCompanies[0].slug" >
                                        <h2  v-html="contactCompanies[0].title" ></h2>
                                    </router-link>
                                    <p v-html="contactCompanies[0].location.address" > </p>
                                    <p v-if="getContactValues(contactCompanies[0].contact_info, 'email').length">
                                        <strong>
                                            {{ getContactValues(contactCompanies[0].contact_info, 'email')[0] }}
                                        </strong>
                                    </p>

                                    <p v-if="getContactValues(contactCompanies[0].contact_info, 'telefono').length">
                                        <strong>Tel:</strong>
                                        {{ getContactValues(contactCompanies[0].contact_info, 'telefono')[0] }}
                                    </p>

                                    <p v-if="getContactValues(contactCompanies[0].contact_info, 'fax').length">
                                        <strong>Fax:</strong>
                                        {{ getContactValues(contactCompanies[0].contact_info, 'fax')[0] }}
                                    </p>

                                    <div v-if="getContactValues(contactCompanies[0].contact_info, 'url').length">
                                        <a
                                            class="urlSite"
                                            :href="getContactValues(contactCompanies[0].contact_info, 'url')[0].startsWith('http')
                                                ? getContactValues(contactCompanies[0].contact_info, 'url')[0]
                                                : 'http://' + getContactValues(contactCompanies[0].contact_info, 'url')[0]"
                                            target="_blank"
                                        >
                                            <strong>Visitar página web</strong>
                                        </a>
                                    </div>
                                </div>
                                <hr>
                            </div>
                            <br>
                        </div>

                        <!-- Ejecutivos -->
                        <div class="ejecutivo" v-if="contacts.length > 0">
                            <h1>EJECUTIVOS</h1>
                            <hr>
                            <div class="scroll-empresa">
                                <template v-for="tmp in contacts" v-if="(contacts !== 'undefined' ) && contacts">
                                    <div class="lista-ejecutivos">
                                        <router-link :to="'/contacto/'+tmp.slug" >
                                            <h2 v-html="tmp.title" style="text-align: left !important"></h2>
                                        </router-link>
                                        <p v-html="tmp.company.position"></p>
                                    </div>
                                    <hr>
                                </template>
                            </div>
                        </div>
                    </div>

                    <!-- Reels -->
                    <div class="reel"  v-if="contactVideos.length > 0 && (typeof contactVideos !== 'undefined' )  ">
                        <h1>REELS</h1>
                        <hr>
                        <div class="scroll-reel">
                            <template v-for="tmp in contactVideos" v-if="contactVideos && (typeof contactVideos !== 'undefined' )" >
                                <div class="lista-ejecutivos">
                                    <a :href="'http://www1.produ.com/videos'+contactVideos.IdVideo">
                                        <h2 v-html="tmp.Titulo"></h2>
                                    </a>
                                    <div class="imagen-reel" >
                                        <a :href="'http://www1.produ.com/videos'+contactVideos.IdVideo">
                                        <div class="feat-image" :style="{ 'background-image': 'url(https://images.produ.com/videos/'+( (contactVideos.Subfolder) ? contactVideos.Subfolder+'/' : '' )+ contactVideos.Ubicacion+')' }" ></div>
                                        </a>
                                    </div>
                                </div>
                                <hr>
                            </template>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const resfulApi = 'https://backend.produ.com/admin/index.php/welcome/';
    const flowBridgeAPIBase = process.env.FLOWBRIDGE_URL;

    import axios from 'axios';
    import Content from './company/Content.vue';

    export default {
        name: 'Company',
        components: {
            'app-content': Content,
        },
        data() {
            return {
                metaTitle: 'Who is Who',
                simpleSearchInput: '',
                countries: [],
                categories: [],
                activities: [],
                categoryIn: 0,
                contactoIn: '',
                empresaIn: '',
                countryIn: 0,
                activityIn: 0,

                companyID: 0,
                contactID: 0,
                company: [],
                contactCompanies: [],
                companies: [],
                contact: [],
                contactVideos: [],
                isMobile: false,
                contacts: [],
                selectedSearchIn: 'ww',
                empresaName: '',
                empresaEmail: '',
                empresaMsg: '',
                empresaTitle: '',
                empresaNameErrorMsg: false,
                empresaEmailErrorMsg: false,
                empresaMsgErrorMsg: false,
                empresaTitleErrorMsg: false,
                emailSent: false,
                isOpen: false,
                contactos: [],
                permalink: 0,
                nombres: '',
                defaultImage: require('@/assets/images/default-image.png'),
                imageCache: {},
            };
        },
        metaInfo() {
            return {
                title: this.metaTitle,
                // meta: [{ property: 'og:url', content: this.metaUrl }],
                // meta: [{ property: 'og:type', content: 'website' }],
                // meta: [{ name: 'author', content: 'PRODU' }],
                // meta: [{ name: 'description', content: this.metaDescr }],
                // meta: [{ name: 'copyright', content: 'PRODU' }],
                // meta: [{ property: 'og:title', content: this.metaTitle }],
                // meta: [{ property: 'og:image', content: this.metaImg }],
            };
        },
        created() {},
        methods: {
            moment: function() {
                return moment();
            },
            // Devuelve un array con los valores de un tipo de contacto dado
            getContactValues: function(contact_info, tipo) {
                if (!Array.isArray(contact_info)) return [];
                return contact_info
                    .filter(item => item.slug === tipo)
                    .map(item => item.value);
            },
            getBanner: function(banners, position) {
                if (!Array.isArray(banners)) return [];
                return banners
                    .filter(item => item.banner_location === position)
                    .map(item => item.banner_smart_ad_code);
            },
            getImageUrl: function(imageUrl) {
                if (!imageUrl || imageUrl.trim() === '') {
                    return this.defaultImage;
                }

                // Si ya validamos esta URL, usar el resultado del cache
                if (this.imageCache.hasOwnProperty(imageUrl)) {
                    return this.imageCache[imageUrl];
                }

                // Por defecto retornar la URL original y validar en background
                this.validateImageInBackground(imageUrl);
                return imageUrl;
            },
            validateImageInBackground: function(imageUrl) {
                if (!imageUrl || imageUrl.trim() === '' || this.imageCache.hasOwnProperty(imageUrl)) {
                    return;
                }

                const img = new Image();

                img.onload = () => {
                    this.$set(this.imageCache, imageUrl, imageUrl);
                };

                img.onerror = () => {
                    // Marcar como error en cache
                    this.$set(this.imageCache, imageUrl, this.defaultImage);

                    // Actualizar todos los items que usan esta imagen
                    this.updateItemsWithFailedImage(imageUrl);
                };

                img.src = imageUrl;
            },
            updateItemsWithFailedImage: function(failedUrl) {
                // Actualizar imágenes en noticias español
                this.contactNews.forEach(item => {
                    if (item.Image === failedUrl) {
                        this.$set(item, 'Image', this.defaultImage);
                    }
                });

                // Actualizar imágenes en noticias inglés
                this.contactNewsE.forEach(item => {
                    if (item.Image === failedUrl) {
                        this.$set(item, 'Image', this.defaultImage);
                    }
                });

                // Actualizar imágenes en videos
                this.contactVideosNew.forEach(item => {
                    if (item.Image === failedUrl) {
                        this.$set(item, 'Image', this.defaultImage);
                    }
                });
            },
            getCompany: async function(companyID) {

                this.companyID = companyID;

                await axios.get(flowBridgeAPIBase + 'companies/slug/'+this.companyID, {
                    params: {
                        fields: 'location,logo,sector_info,banners,contact_info,organization_chart,who'
                    }
                }).then(response => {
                    const seletedCompany = response.data.data;
                    this.company = {
                        nameRecord: seletedCompany.title,
                        CompanyName: seletedCompany.title,
                        // Title
                        Images: seletedCompany.logo.url,
                        Telefono1: this.getContactValues(seletedCompany.contact_info, 'telefono')[0],
                        Fax1: this.getContactValues(seletedCompany.contact_info, 'fax')[0],
                        URL: this.getContactValues(seletedCompany.contact_info, 'url')[0],
                        WWonlineBannerTopFM: this.getBanner(seletedCompany.banners, 'banner-top')[0],
                        WWonlineBannerLat1FM: this.getBanner(seletedCompany.banners, 'banner-lateral')[0],
                        // WWonlineBannerTopOTTFM
                        // WWonlineBannerLat1OTTFM
                        // WWOTTInterstitial
                        // Especialidad
                        citiName: seletedCompany.location.city,
                        // type
                        id: seletedCompany.post_id,
                        // Module
                        // IDRecord
                        // CompanyGroup
                        Address1: seletedCompany.location.address,
                        Email: this.getContactValues(seletedCompany.contact_info, 'email')[0],
                        Descripcion: seletedCompany.description,
                        FundacionYear: seletedCompany.foundation,
                        permalink: seletedCompany.slug,
                        NombreActivity: seletedCompany.sector_info.principal.activity_category.name,
                        NombreCategory: seletedCompany.sector_info.principal.category_company.name
                    }

                    this.contactCompanies = [seletedCompany]
                    this.contact = (seletedCompany.who && seletedCompany.who.organization_chart && seletedCompany.who.organization_chart.principal) || null;
                    this.contacts = (seletedCompany.who && seletedCompany.who.organization_chart && seletedCompany.who.organization_chart.contacts) || [];

                    // Actualizar el título de la página
                    if (this.company && this.company.CompanyName) {
                        this.metaTitle = this.company.CompanyName;
                    } else {
                        this.metaTitle = 'Who is Who';
                    }

                    this.$nextTick(function() {});
                });
            },
            getVideosByCompanyWS: async function(companyID, pageIN) {
                this.companyID = companyID;

                await axios
                    .post(resfulApi + 'get_VideosCompaniesWWFWS', {
                        token:
                            'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                        companyIN: this.companyID,
                        typeIN: 1,
                        pageIN: 0,
                    })
                    .then(response => {
                        this.contactVideos = response.data.result;
                        this.$nextTick(function() {});
                    });
            },
            sendEmailEmpresaWW: async function(e) {
                this.errors = [];
                this.empresaNameErrorMsg = false;
                this.empresaMsgErrorMsg = false;
                this.empresaEmailErrorMsg = false;

                if (!this.empresaTitle) {
                    this.empresaNameErrorMsg = true;
                    this.errors.push('Titulo requerido.');
                }
                if (!this.empresaMsg) {
                    this.empresaMsgErrorMsg = true;
                    this.errors.push('Mensage requerido.');
                }

                if (!this.empresaEmail || !this.validEmail(this.empresaEmail)) {
                    this.empresaEmailErrorMsg = true;
                    this.errors.push('Valid Email required.');
                }

                if (this.company && this.errors.length == 0) {
                    await axios
                        .post(resfulApi + 'sendEmailEmpresaWW', {
                            token:
                                'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                            email: this.empresaEmail,
                            title: this.empresaTitle,
                            msg: this.empresaMsg,
                            emailD: this.company.Email,
                        })
                        .then(response => {
                            this.emailSent = parseInt(response.data) == 1;
                            this.$nextTick(function() {});
                        });
                }
            },

            advanceSearch: async function(page) {
                this.currentPage = page;
                this.$router.push(
                    '/advancesearch/' +
                        this.contactoIn +
                        '_' +
                        this.empresaIn +
                        '_' +
                        this.countryIn +
                        '_' +
                        this.categoryIn +
                        '_' +
                        this.activityIn
                );
            },
            simpleSearch: function(e) {
                if (this.simpleSearchInput && this.isActiveSearch()) {
                    this.nombres =
                        this.nombres == '' ? this.simpleSearchInput : this.nombres;
                    this.$router.push({
                        name: 'Search',
                        params: {
                            permalink: this.permalink,
                            tipo: this.selectedSearchIn,
                            search: this.simpleSearchInput,
                            nombres: this.nombres,
                        },
                    });
                }
            },
            getDataForm: async function() {
                await axios
                    .post(resfulApi + 'getCountriesWWFWS', {
                        token:
                            'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                    })
                    .then(response => {
                        this.countries = response.data.countries;
                        this.categories = response.data.categories;

                        this.$nextTick(function() {});
                    });

                this.getActivity();
            },
            getActivity: async function() {
                if (this.categoryIn) {
                    await axios
                        .post(resfulApi + 'getActivitiesByCategoryWWFWS', {
                            token:
                                'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                            category: this.categoryIn,
                        })
                        .then(response => {
                            this.activities = response.data;

                            this.$nextTick(function() {});
                        });
                }
            },
            getDataClick: async function(newVal) {
                this.companyID = newVal;
                this.$route.params.empresa = this.companyID;
                this.getCompany(newVal);
                this.getVideosByCompanyWS(this.companyID);
            },
            isActiveSearch() {
                return !this.selectedSearchIn || this.simpleSearchInput.length <= 0
                    ? false
                    : true;
            },
            getList: function() {
                this.simpleSearchInput.length > 3
                    ? this.getSearchWWFWS()
                    : (this.isOpen = false);
            },
            getSearchWWFWS: async function() {
                await axios
                    .post(resfulApi + 'getSearchWWFWS', {
                        token:
                            'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                        search: this.simpleSearchInput,
                        tipo: this.selectedSearchIn,
                    })
                    .then(response => {
                        this.contactos = response.data;
                        this.contactos.length > 0
                            ? (this.isOpen = true)
                            : (this.isOpen = false);
                    });
            },
            setResult: async function(result) {
                this.simpleSearchInput = result.nombres;
                this.permalink = result.permalink;
                this.nombres = result.nombres;
                this.isOpen = false;
                var typeSearch = this.redirectConsulta(
                    result.nameRecord,
                    result.GuiaOTT
                );
                this.$router.push('/' + typeSearch + '/' + result.permalink);
            },
        },
        beforeMount() {},
        mounted: function() {
            this.companyID = this.$route.params.empresa;

            this.getCompany(this.companyID);
            this.isMobile = this.checkMobile();
        },
        watch: {
            '$route.params.empresa'(newId, oldId) {
                this.companyID = newId;
                this.isMobile = this.checkMobile();

                this.getCompany(this.companyID);
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .filtro-negro a:hover {
        cursor: pointer;
    }

    a:hover {
        cursor: pointer;
    }

    @media only screen and (max-width: 650px) {
        .blog-content img,
        h1,
        h3,
        a,
        h4 {
            text-align: center !important;
        }

        .container-who-who {
            float: left;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Company.vue